import React, { useState, forwardRef, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash-es';
import { changeDateToGivenFormat, getCurrentDate } from '../../../../../Utils/DateUtils';
import { AppConstant } from '../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../sagas/sagaActions'
import { getUserSelector } from '../../../../../redux/reducers/reducerSlices/UserReducer';
import { getPoSSselector } from '../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import { fetchPoListCommonFunc } from './Common/FetchPOList';
import { changeFormatWithoutTz, createDropDownDataArray, formDropDownData, showAlert } from '../../../../Assests/Utility';
import html2pdf from 'html2pdf.js';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { fetchDockListCommonFunc } from '../WarehouseMetaData/Forms/DocksMeta/Common/FetchDockList';
import './CreatePo.css';
import { getWhMetaDataReducerSlice } from '../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import moment from 'moment-timezone';
import SsPOListSS from './SsPOList/SsPOListSS';
import CustomButtonSS from '../../../Common/CustomButton/CustomButtonSS';
import WarehouseSearchSS from '../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import { CustomDynamicFormSS } from '../../../Common/CustomForm/CustomDynamicFormSS';
import SSPopup from '../../../Common/Popup/SSPopup/SSPopup';
import ScheduleProWrapper from '../../../SmartSchedule/SchedulePro/ScheduleProWrapper';
import { smartScheduleSelector } from '../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import DownloadSectionBECustomFeilds from '../../Components/DownloadSection/DownloadSectionBECustomFeilds';
import { getRemoteConfigSelector } from '../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import MultiSelectDropDownNew from '../../../Common/MultiSelectDropDown/MultiSelectDropDownNew';
import SendEmailSS from '../../../sendEmailSS';
import { getPoIntakeMangementSelector } from '../../../../../redux/reducers/reducerSlices/PoIntakeMangementReducer';

const CreatePOSS = (props) => {
    const dispatch = useDispatch();
    const { themeSelected } = props;
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [editData, setEditData] = useState({});
    const [resetFormData, setResetFormData] = useState(0);
    const [selectedDate, setSelectedDate] = useState('');
    const [searchStr, setSearchStr] = useState(null);
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse, cu_id, userAccountDetails, userType } = userPermission;
    moment.tz.setDefault(selectedWarehouse?.TimeZone); // Set Warehouse Timezone
    const [dockListArr, setDockListArr] = useState([]);
    const divRef = useRef(null);
    const pOSS = useSelector(getPoSSselector);
    const [particularFieldValue, setParticularFieldValue] = useState({});
    const [currentTable, setCurrentTable] = useState(null);
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { whMetaDocksList } = whMetaData;
    const { poSSArr, operationObj, isLoading } = pOSS;
    const ss = useSelector(smartScheduleSelector);
    const { isDownloadLoading, isActiveCommanDownloadPopup, commanDownloadMessage } = ss;

    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const [filterSelected, setFilterSelected] = useState(["Not Scheduled"])
    const [noShowStatus, setNoShowStatus] = useState(false)
    const [selectedDock, setSelectedDock] = useState(null)
    const [emailLoading, setEmailLoading] = useState(false)
    const [customBtnClicked, setCustomBtnClicked] = useState(false)
    const [showEmailModal, setShowEmailModal] = useState(false)
    const [selectedObj, setSelectedObj] = useState(false)
    const [showVendorDropdown, setShowVendorDropdown] = useState(false)
    const [uniqueVendorNamesArray, setUniqueVendorNames] = useState([])
    const poIntakeMangementDetails = useSelector(getPoIntakeMangementSelector);
    const { poIntakeLVendorDockList } = poIntakeMangementDetails
    const [popupshowMorePoObj, setPopupshowMorePoObj] = useState(null)
    const [carrierListState, setCarrierListState] = useState([]);
    const [selectedCarrier, setSelectedCarrier] = useState(null);

    const [selectedCarrierId, setSelectedCarrierId] = useState(null);
    const ssReducer = useSelector(smartScheduleSelector);
    const { carrierList } = ssReducer;
    const [searchableSelectFormData, setSearchableSelectFormData] = useState(null)

    useEffect(() => {
        const container = divRef.current;
        setCurrentTable(container.children[0].children[0].children[0]);
    })

    /* useEffect to call fetch Carrier data function*/
    useEffect(() => {
        formCarrierListData();
    }, [carrierList]);

    /** Drowdown change handler */
    const onChangeValue = (props) => {
        //console.log(props)
        setSelectedCarrier(props)
    }

    const onCarrierSelcted = (props) => {
        dispatch({ type: sagaActions.SS_CLEAR_CARRIER_LIST })
        setCarrierListState([])
        if (props.length > 2) {
            dispatch({
                type: sagaActions.SS_GET_CARRIER_LIST,
                payload: { carrier: props },
            });
        }
    };

    const formCarrierListData = () => {
        if (_.size(carrierList)) {
            const carrierData = carrierList.map((el) => {
                return {
                    value: el.carrier_id,
                    label: el.carrier_name
                };
            });
            setCarrierListState([...carrierData]);
        }
        else {
            setCarrierListState([]);
        }
    };

    const onCreateSelected = (carrierName) => {
        // console.log(carrierName)
        setSelectedCarrier({
            label: carrierName,
            value: null
        });
        setSearchableSelectFormData({
            value: null,
            label: carrierName
        })
        // console.log(searchableSelectFormData)
    }
        ;

    const downloadPdfData = () => {
        const table = currentTable;
        const columnsToDownload = [0, 1, 2, 3, 4, 5, 6];
        const allColumns = currentTable.querySelectorAll('tr');
        allColumns.forEach((row) => {
            Array.from(row.cells).forEach((cell, index) => {
                if (!columnsToDownload.includes(index)) {
                    cell.style.display = 'none';
                }
            });
        });

        html2pdf()
            .set({
                margin: 10,
                filename: 'PO List.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { dpi: 192, letterRendering: true },
                jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
            })
            .from(currentTable)
            .save();
        setTimeout(() => {
            allColumns.forEach((row) => {
                Array.from(row.cells).forEach((cell) => {
                    cell.style.display = '';
                });
            });
        }, [100])
    }

    const downloadExcelData = () => {
        const columnsToDownload = [0, 1, 2, 3, 4, 5, 6];
        const filteredTable = Array.from(currentTable.rows).map(row => {
            const filteredCells = Array.from(row.cells)
                .filter((cell, index) => columnsToDownload.includes(index))
                .map(cell => cell.innerText);
            return filteredCells;
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(filteredTable);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
        const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(excelData, 'PO List.xlsx');
    };


    useEffect(() => {
        setLoading(false);
        setShowModal(false);
        setDockListArr([]);
        setTimeout(() => {
            fetchDockList()
        }, [1000])

        // Clear Vendor list data when component unmounts
        return () => {
            dispatch({
                type: sagaActions.FETCH_POINTAKE_DOCK_VENDOR_LIST, payload: {
                    "CRUDTYPE": "C"
                }
            })
        }
    }, [])

    useEffect(() => {
        if (_.size(poIntakeLVendorDockList)) {
            setShowVendorDropdown(true)
            const data = formatVendorDataforDropDown(poIntakeLVendorDockList)
            const uniqueData = _.uniqBy(data, 'Name')
            const sortedData = _.sortBy(uniqueData, 'Name');
            setUniqueVendorNames(sortedData)
        }
    }, [poIntakeLVendorDockList])

    const formatVendorDataforDropDown = (data) => {
        return data.map(el => {
            return {
                ID: el.ID + "_" + el.IDDock,
                Name: el.Vendor
            }
        })
    }

    const fetchDockList = () => {
        const { apiParams, operationObj } = fetchDockListCommonFunc(selectedWarehouse);
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj })
        dispatch({
            type: sagaActions.FETCH_POINTAKE_DOCK_VENDOR_LIST, payload: {
                "IDWarehouse": selectedWarehouse.ID.toUpperCase(),
                "CRUDTYPE": "S"
            }
        })
    };

    useEffect(() => {
        if (operationObj.type) {
            setLoading(false);
            setEmailLoading(false)
            switch (operationObj.type) {
                case 'Create PO':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.poSection.createPoSuccess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.poSection.createPoFailure + `: ${operationObj.message}`);
                    }
                    break;
                case 'Edit PO':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.poSection.updatePoSuccess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.poSection.updatePoFailure + `: ${operationObj.message}`);
                    }
                    break;
                case 'Upload PO':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.poSection.uploadPoSuccess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.poSection.uploadPoFailure + `: ${operationObj.message}`);
                    }
                    break;
                default:
            }
        }
    }, [operationObj])

    const handleApiResponse = (result, message) => {
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            fetchPoList()
            if (customBtnClicked) {
                setShowEmailModal(true)
            }
        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);
        }
        dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
        setCustomBtnClicked(false)
    }

    useEffect(() => {
        if (operationObj && operationObj.type && operationObj.type === 'Fetch POs') {
            if (poSSArr) {
                setLoading(false);
                setShowModal(false)
            }
        }
    }, [poSSArr])

    const fetchPoList = (pageNo = 1, limit = PaginationDefaultLimit) => {
        const { apiParams, operationObj } = fetchPoListCommonFunc(selectedWarehouse, pageNo, limit, searchStr, filterSelected, noShowStatus);
        dispatch({ type: sagaActions.UPDATE_PO_LIST, payload: apiParams, operationObj: operationObj });
    }

    const editPO = (data, index) => {
        const selectedDock = (_.find(dockListArr, { ID: data?.IDDock }));
        const selectedVendor = (_.find(uniqueVendorNamesArray, { Name: data?.VendorName?.trim() }));

        const editData1 = {
            "PoNumber": data.PoNumber,
            "OrderNumber": data.OrderNumber,
            "VendorName": showVendorDropdown ? selectedVendor?.ID : data?.VendorName,
            "BuyerName": data.BuyerName,
            "IDCarrier": data.IDCarrier,
            "Commodity": data.Commodity,
            "Cases": data.ItemsCases,
            "Pallets": data.Pallets,
            "Weight": data.Weight,
            "Quantity": data.Quantity,
            "ProduceType": selectedDock?.ID || null,
            "custom-date-picker": moment(data.DueDate).utc().format('YYYY-MM-DD'),
            "ZipCode": data.ReceivingZipCode,
            "Remarks": data.Remarks,
            "PoCreatedOn": data.PoCreatedOn,
            "PoCreatedBy": data.PoCreatedBy,
            "WarehouseId": data.IDWarehouse,
            "IDPO": data.IDPO,
            "PoStatus": data.PoStatus,
            "Door": data.Door,
            "LoadType": data.LoadType ? data?.LoadType?.toUpperCase() : null,
            "IDStandingAppointmentBlockRule": data?.IDStandingAppointmentBlockRule || null,
            "ApptScheStatus": data?.ApptScheStatus
        }
        setSelectedCarrier({
            "label": data.CarrierName,
            "value": data.IDCarrier,
        })
        setShowModal(true);
        setEditData({ ...editData1 });
        setParticularFieldValue({ ...editData1 });
    }

    const getDocksList = () => {
        const docksList = whMetaDocksList && whMetaDocksList.length && whMetaDocksList.map((ele, index) => {
            if (ele && ele.DockStatus) {
                return (
                    <option key={ele.Name} value={ele.ID}>
                        {ele.Name}
                    </option>
                );
            } else {
                return null;
            }
        })
        return _.compact(docksList);
    }

    const getVendorList = () => {
        const docksList = uniqueVendorNamesArray && uniqueVendorNamesArray.length && uniqueVendorNamesArray.map((ele, index) => {
            return (
                <option key={ele.Name} value={ele.ID}>
                    {ele.Name}
                </option>
            );

        })
        return _.compact(docksList);
    }


    useEffect(() => {
        if (whMetaDocksList && whMetaDocksList.length) {
            setDockListArr(whMetaDocksList)
        }
    }, [whMetaDocksList])

    const TUSCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className="customDatePickerInput" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const selectedDateValue = () => {
        return changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat)
    }

    const getFormFieldData = (data, name, control,
        inputs,
        searchableSelectFormData) => {
        if (name === 'custom-date-picker') {
            setSelectedDate(changeDateToGivenFormat(data, AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
        }
        if (name === 'ProduceType') {
            let selectedDock = whMetaDocksList && _.size(whMetaDocksList) && whMetaDocksList.filter((el) => el.ID === data)
            setSelectedDock(selectedDock[0])
        }
        if (name === 'IDCarrier') {
            setSelectedCarrierId(data);
            setSelectedCarrier(data);
            // console.log(searchableSelectFormData)
            if (searchableSelectFormData) {
                setSearchableSelectFormData(searchableSelectFormData);
            }
            const selectedCarrierObj = carrierList?.find(
                el => el.IDCarrier === searchableSelectFormData?.value
            );
            dispatch({ type: sagaActions.SS_CLEAR_CARRIER_LIST })
            setCarrierListState([])

            setSelectedCarrier({
                value: data?.IDCarrier,
                label: data?.CarrierName
            })
            setSearchableSelectFormData({
                value: data?.IDCarrier,
                label: data?.CarrierName
            })

        }

    };

    const getVendorObj = () => {
        if (showVendorDropdown) {
            return {
                name: "VendorName",
                type: "select",
                size: "col-sm-6",
                position: 3,
                title: AppConstant.loadManagement.purchaseOrderDetails.vendor_name,
                formValidation: {
                    required: true,
                },
                getSelectData: getVendorList,
            }
        } else {
            return {
                name: "VendorName",
                type: "text",
                size: "col-sm-6",
                position: 3,
                title: AppConstant.loadManagement.purchaseOrderDetails.vendor_name,
                formValidation: {
                    required: true,
                }
            }
        }

    }

    const formFieldList = [
        {
            name: "PoNumber",
            type: "text",
            size: "col-sm-6",
            position: 1,
            placeholder: '',
            title: AppConstant.poManagement.poDetails.poNumber,
            formValidation: {
                required: true,
            },
            disabledField: !_.isEmpty(editData) && !editData?.IDStandingAppointmentBlockRule ? true : false
        },
        {
            name: "OrderNumber",
            type: "text",
            size: "col-sm-6",
            position: 2,
            title: AppConstant.smartScheduler.poSection.orderNumTitle,
            formValidation: {
                required: false,
            }
        },
        getVendorObj(),
        {
            name: "BuyerName",
            type: "text",
            size: "col-sm-6",
            position: 4,
            title: AppConstant.smartScheduler.poSection.buyerNameTitle,
            formValidation: {
                required: false,
            }
        },
        {
            name: "Commodity",
            type: "text",
            size: "col-sm-6",
            position: 7,
            title: AppConstant.smartScheduler.poSection.commodity,
            formValidation: {
                required: true,
            }
        },
        {
            name: "Pallets",
            type: "number",
            size: "col-sm-6",
            position: 13,
            title: AppConstant.smartScheduler.poSection.palletsCount,
            formValidation: {
                required: selectedDock?.CapacityModeling === 'PPH' || selectedDock?.CapacityModeling === 'TPH' ? true : false,
                numberType: true
            }
        },
        {
            name: "Quantity",
            type: "string",
            size: "col-sm-2 itemsCasesParentContainer",
            position: 9,
            title: AppConstant.smartScheduler.poSection.quantity,
            formValidation: {
                required: false,
                numberType: true
            }
        },
        {
            name: "Cases",
            type: "string",
            size: "col-sm-2 itemsCasesParentContainer",
            position: 10,
            title: AppConstant.loadManagement.purchaseOrderDetails.cases,
            formValidation: {
                required: selectedDock?.CapacityModeling === 'CPH' ? true : false,
                numberType: true
            }
        },
        {
            name: "Weight",
            type: "text",
            size: "col-sm-6 ",
            position: 12,
            title: AppConstant.smartScheduler.poSection.weight,
            formValidation: {
                required: false,
            }
        },
        {
            size: "col-sm-6",
            name: "custom-date-picker",
            // Use native <input type="date"> — validation in CustomDynamicFormSS handles
            // 4-digit year enforcement and calendar-correctness (e.g. 04/31 is rejected).
            type: "date",
            position: 6,
            title: AppConstant.smartScheduler.poSection.dueDate,
            formValidation: {
                required: true,
                // Triggers validateDateInput() inside CustomDynamicFormSS.validate()
                validateDate: true,
            }
        },
        {
            name: "ProduceType",
            type: "select",
            size: "col-sm-6",
            position: 5,
            title: AppConstant.smartScheduler.poSection.produceType,
            formValidation: {
                required: showVendorDropdown ? false : true,
            },
            getSelectData: getDocksList,
        },
        {
            name: "ZipCode",
            type: "text",
            size: "col-sm-6",
            position: 8,
            title: AppConstant.poManagement.poDetails.facilityZipCode,
            formValidation: {
                required: false,
            },
            disabledField: true
        },
        {
            name: "Remarks",
            type: "text",
            size: "col-sm-6 weightsParentContainer",
            position: 11,
            title: AppConstant.smartScheduler.poSection.remarks,
            formValidation: {
                required: false,
            }
        },
        {
            name: "LoadType",
            type: "radio",
            size: "col-sm-6 mt-2 radioButtonText",
            position: 14,
            title: 'Select Load Type:',
            formValidation: {
                required: true,
            },
            radiconfig: [{
                label: "Inbound",
                value: "INBOUND"
            },
            {
                label: "Outbound",
                value: "OUTBOUND"
            }]
        },
        {
            name: "IDCarrier",
            type: "select_with_input_search_add_button_create_po_SS",
            size: "col-sm-6 mb-3 f-12",
            parentClass: "inputTitle",
            componentClassName: "mt-1 border border-1 rounded-1 border-dark",
            inputTitle: "Select Carrier",
            position: 26,
            title: AppConstant.reports.scheduledLoadStatus.tableHeaders.carrierName,
            //customStylesLight: customStylesLight,
            placeholderText: "Select a carrier from the list",
            onInputChange: onCarrierSelcted,
            onChange: onChangeValue,
            defaultValue: !_.isEmpty(selectedCarrier)
                ? selectedCarrier
                : "Select a carrier from the list",
            isLoading: false,
            isClearable: true,
            isSearchable: true,
            options: carrierListState,
            formatCreateLabel: () => { },
            loadingMessage: "Please wait loading....",
            formValidation: {
                required: false,
            },
            isEditProcess: _.isEmpty(editData) ? "false" : "true",
            hideInForm: !_.isEmpty(editData) && editData?.ApptScheStatus === "Not Scheduled" ? false : true,
            searchableSelectFormData: searchableSelectFormData,
            handleCreateOption: onCreateSelected,
        }
    ]


    const openSendEmail = () => {
        return <SendEmailSS closeSendMailpopup={() => setShowEmailModal(false)} poDetails={selectedObj} type='created'></SendEmailSS>
    }

    const showSendEmailPopup = () => {
        const popupObj = {
            id: 'createAppointment',
            modalLabel: 'sendEmail',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: 'Send Email',
            bodyText: openSendEmail(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <SSPopup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={() => setShowEmailModal(false)} themeSelected={themeSelected} showModal={showEmailModal} />
    }

    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };

    const submitbtnData = {
        show: true,
        text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle,
    };

    const customBtnData = {
        show: true,
        text: `${AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle} & Email`,
        className: "btn-styled me-2 h-100"
    };

    const getSummitedFormData = (data) => {
        setLoading(true);
        let apiParams = {}
        // console.log(selectedCarrier)
        // console.log(selectedCarrierId)
        const selectedDock = (_.find(dockListArr, { ID: data.ProduceType }));
        const selectedVendor = (_.find(uniqueVendorNamesArray, { ID: data.VendorName }));
        const operationObj = {
            type: '',
            status: ''
        }

        if (data.WarehouseId) {
            const apiTempParams = {
                "PoNumber": data.PoNumber,
                "OrderNumber": data.OrderNumber,
                "VendorName": showVendorDropdown ? selectedVendor.Name : data.VendorName,
                "BuyerName": data.BuyerName,
                "Commodity": data.Commodity,
                "Cases": data.Cases,
                "PalletsCount": data.Pallets,
                "Weight": data.Weight,
                "CRUDTYPE": "U",
                "Quantity": data.Quantity,
                "DueDate": changeDateToGivenFormat(data['custom-date-picker'], 'YYYY-MM-DD hh:mm:ss'),
                "ProduceType": data?.ProduceType || null,
                "ZipCode": data.ZipCode ? data.ZipCode : selectedWarehouse.Zip,
                "PoCreatedOn": data.PoCreatedOn,
                "CreatedOn": data.PoCreatedOn,
                "CreatedBy": cu_id,
                "PoCreatedBy": data.PoCreatedBy,
                "WarehouseId": selectedWarehouse.ID,
                "IDPO": data.IDPO,
                "WarehouseName": selectedWarehouse.Name,
                "DockName": selectedDock?.Name || null,
                "PoStatus": data.PoStatus,
                "Door": data.Door,
                "Remarks": data.Remarks,
                "UpdatedBy": cu_id,
                "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "LoadType": data.LoadType,
                "IDCarrier": selectedCarrierId,
            }

            operationObj.type = 'Edit PO'
            apiParams = { ...data, ...apiTempParams }
        }
        else {
            apiParams = {
                "PoNumber": data.PoNumber,
                "OrderNumber": data.OrderNumber || null,
                "VendorName": showVendorDropdown ? selectedVendor?.Name : data?.VendorName,
                "BuyerName": data.BuyerName || null,
                "Commodity": data.Commodity,
                "Cases": data.Cases || null,
                "PalletsCount": data.Pallets,
                "Weight": data.Weight || null,
                "CRUDTYPE": "I",
                "Quantity": data.Quantity || null,
                "DueDate": changeDateToGivenFormat(data['custom-date-picker'], 'YYYY-MM-DD hh:mm:ss'),
                "ProduceType": data?.ProduceType || null,
                "ZipCode": data.ZipCode ? data.ZipCode : selectedWarehouse.Zip,
                "CreatedBy": cu_id,
                "CreatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "WarehouseId": selectedWarehouse.ID,
                "IDPO": null,
                "WarehouseName": selectedWarehouse.Name,
                "DockName": selectedDock?.Name || null,
                "PoStatus": null,
                "Door": null,
                "Remarks": data.Remarks,
                'PoCreatedOn': getCurrentDate(),
                'PoCreatedBy': cu_id,
                "UpdatedBy": cu_id,
                "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "LoadType": data.LoadType,
                "IDCarrier": selectedCarrierId
            }
            operationObj.type = 'Create PO'
        }
        //console.log(apiParams)
        dispatch({ type: sagaActions.UPDATE_PO_LIST, payload: apiParams, operationObj: operationObj })
    };

    const closeCurrentpopup = () => {
        setShowModal(false);
        setCustomBtnClicked(false)
    }

    const SaveAndEmailHandler = (data) => {
        setCustomBtnClicked(true)
        setSelectedObj({ ...data, IDWarehouse: selectedWarehouse.ID })
        setEmailLoading(true)
        getSummitedFormData(data)
        setLoading(false)
    }

    const createForm = () => {
        return (
            <CustomDynamicFormSS
                formFieldList={formFieldList}
                sort={true}
                cancelBtn={cancelbtndata}
                submitbtn={submitbtnData}
                customBtn={customBtnData}
                customBtnLoading={emailLoading}
                customBtnSubmit={true}
                customBtnHandler={SaveAndEmailHandler}
                themeSelected={themeSelected}
                getSummitedFormData={getSummitedFormData}
                getFormFieldData={getFormFieldData}
                editFormData={editData}
                loading={loading}
                resetFormData={resetFormData}
                setParticularFieldValue={particularFieldValue}
            />
        );
    };

    const showCreatePOPopup = () => {
        const popupObj = {
            id: 'createCompanyGroupFormPopup1',
            modalLabel: 'createCompanyGroupFormPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'xl',
            title: !Object.keys(editData).length ? AppConstant.poManagement.poDetails.createOrder : AppConstant.poManagement.poDetails.editOrder,
            bodyText: createForm(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <SSPopup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeCurrentpopup} themeSelected={themeSelected} showModal={showModal} />
    }

    const openCreateForm = () => {
        setShowModal(true);
        setParticularFieldValue({ 'ZipCode': selectedWarehouse.Zip });
        setEditData({});
    }

    useEffect(() => {
        if (isActiveCommanDownloadPopup) {
            const popupshowMorePoObj = {
                id: 'popupshowMorePoObj',
                modalLabel: 'showMorePo',
                showClose: true,
                showfooter: true,
                showHeader: true,
                sendDriverNotification: false,
                modalSize: 'md',
                title: 'Download Report Notification',
                bodyText: <div>{commanDownloadMessage}</div>,
                subText: "",
                keyboard: false,
                backdrop: "static",
                footerBtn: {
                    btn1: {
                        show: true,
                        text: AppConstant.commonStrings.close
                    },
                    btn2: {
                        show: false,
                        text: AppConstant.commonStrings.no
                    }
                },
            }
            setPopupshowMorePoObj({ ...popupshowMorePoObj })
        } else {
            setPopupshowMorePoObj(null)
        }
    }, [isActiveCommanDownloadPopup])

    const closeSelectPopopup = () => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP })
    }

    const downloadData = (type) => {
        let payload = {
            subDomain: "poManagement",
            heading: "Order Management report",
            downloadType: type,
            fileName: "poManagementReport-" + userAccountDetails?.UserName + "-" + Date.now(),
            options: {
                startDate: null,
                endDate: null,
                WarehouseId: selectedWarehouse.ID,
                ID: userType === 'CARRIER' ? userAccountDetails?.IDCarrier : selectedWarehouse.ID,
                type: userType === 'CARRIER' ? 'carrier' : 'warehouse',
            },
            userDetails: {
                CUID: userAccountDetails?.CUID,
            }
        }
        return payload
        // dispatch({ type: sagaActions.DOWNLOAD_REPORT_COMMON, payload });
    }

    //Call Download Report API
    const downloadReport = (payload) => {
        dispatch({ type: sagaActions.DOWNLOAD_REPORT_COMMON, payload });
    }

    //Colums List for download column specific report
    const columnList = [
        {
            name: "PO/SO",
            value: "PoNumber"
        },
        {
            name: "Dock-Type",
            value: "DockName"
        },
        {
            name: "Pallets-Count",
            value: "Pallets"
        },
        {
            name: "Carrier",
            value: "CarrierName"
        },
        {
            name: "Appt-Time",
            value: "ApptStartTime",
            isDate: true,
            isTime: true
        },
        {
            name: "CreatedOn",
            value: "PoCreatedOn",
            isDate: true
        },
        // {
        //  name:"UpdatedOn",
        //     value:"UpdatedDate",
        //     isDate:true
        // },
        {
            name: "Due Date",
            value: "DueDate",
            isDate: true
        },
        {
            name: "Status",
            value: "ApptScheStatus"
        },
        {
            name: "Vehicle Type",
            value: "vehicleType"
        },
        {
            name: "Load Type",
            value: "LoadType"
        }
    ]

    /**
  * options for multi select dropdown
     */
    const multiSelectDDOptions = [
        {
            id: 1,
            name: "All"
        },
        {
            id: 2,
            name: "Not Scheduled"
        },
        {
            id: 3,
            name: "Scheduled"
        },
        {
            id: 4,
            name: "Rescheduled"
        },
        {
            id: 5,
            name: "In Progress"
        },
        {
            id: 6,
            name: "Completed"
        },
        {
            id: 7,
            name: "Date Expired"
        }
    ]

    return (
        <ScheduleProWrapper>
            <div className='container-fluid m-1 createPo-wrapper-ss p-3'>
                {/* <Header {...props} />
   <Navigationbar {...props} /> */}
                <h4>Order Management</h4>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='mt-3 align-items-center'>
                        <div className="d-flex mb-2 align-items-center">
                            <div className="h-auto me-4">
                                <CustomButtonSS
                                    isLoading={false}
                                    title={AppConstant.poManagement.poDetails.createOrder}
                                    className={"btn-highlighted f-12 me-3"}
                                    onClick={() => openCreateForm()}
                                    isIcon={true}
                                    iconClass='fa-solid fa-plus'
                                />
                            </div>
                            <div className="h-auto me-4">
                                <CustomButtonSS
                                    isLoading={false}
                                    title={AppConstant.smartScheduler.poSection.uploadPoBulk}
                                    className={"btn-white f-12 me-3"}
                                    onClick={() => navigate("/bulkUploadPO")}
                                    isIcon={true}
                                    iconClass='fa-solid fa-layer-group'
                                />
                            </div>
                        </div>
                    </div>

                    <div className='d-flex w-auto m-3 justify-content-between align-items-center'>
                        <div className='d-flex gap-2 align-items-center me-2'>
                            <p>Select filters</p>
                            <MultiSelectDropDownNew
                                placeholder={(multiSelectDDOptions && multiSelectDDOptions.length) ? multiSelectDDOptions[1]?.name : "Not Scheduled"}
                                options={multiSelectDDOptions}
                                id={'po-filter'}
                                filterSelected={filterSelected}
                                setFilterSelected={setFilterSelected}
                                loading={isLoading}
                            />
                        </div>
                        <div className='d-flex gap-2 align-items-center me-2'>
                            <label htmlFor="noShowCheckbox" style={{ cursor: 'pointer', marginBottom: 0 }}>
                                No Show
                            </label>
                            <input
                                type="checkbox"
                                id="noShowCheckbox"
                                checked={noShowStatus}
                                onChange={(e) => setNoShowStatus(e.target.checked)}
                                style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                            />
                        </div>
                        <div className="me-2">

                            <WarehouseSearchSS
                                placeholder={"Search PO/SO"}
                                inputValue={searchStr}
                                cancelSearch={() => setSearchStr('')}
                                onChangeHandler={(text) => setSearchStr(text)} />
                        </div>
                        <DownloadSectionBECustomFeilds isSchedulePro={true} downloadData={downloadData} isLoading={isDownloadLoading} isDisabled={isDownloadLoading} columnList={columnList} downloadReport={downloadReport} showDateRange={true} showEmail={true} emailValue={userAccountDetails && userAccountDetails.Email ? userAccountDetails.Email : ""}
                            // weeks={2}
                            monthLimit={3}

                            filterSelected={filterSelected} noShow={noShowStatus} showPoFilter={true} filterOptions={multiSelectDDOptions} dateRangeDisclaimerText={AppConstant.appointmentReportSummary.dateFilterInfoOrderManagement} />
                    </div>
                </div>
                <div className='d-flex justify-content-end'>
                    <p className='f-12 fst-italic me-3 mb-1 color-red'>{AppConstant.appointmentReportSummary.dateFilterInfoOrderManagementList}</p>
                </div>
                <div className='' ref={divRef}>
                    <SsPOListSS searchStr={searchStr} editPOAction={(poObj, index) => editPO(poObj, index)} showPopup={() => openCreateForm()} themeSelected={themeSelected} filterSelected={filterSelected} noShowStatus={noShowStatus} setSelectedDataObj={setSelectedObj} setShowEmailModal={setShowEmailModal} />
                </div>
                {showCreatePOPopup()}
                {showSendEmailPopup()}
                {isActiveCommanDownloadPopup ? <SSPopup {...popupshowMorePoObj} popupBtnHandler={() => dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP })} closepopup={closeSelectPopopup} themeSelected={themeSelected} showModal={isActiveCommanDownloadPopup} /> : ''}
            </div>
        </ScheduleProWrapper>
    )
}

export default CreatePOSS;
